import {QueuedCommand} from "../../entities/QueuedCommand";
import {AdminPagingModel} from "./AdminPagingModel";
import {EventService} from "../../services/EventService";
import {NotificationService} from "../../services/NotificationService";
import {GridBookmarkService} from "../../services/GridBookmarkService";

export class CommandAdminPagingModel extends AdminPagingModel<QueuedCommand>{
        static $inject = ['$q','QueuedCommandService','NotificationService','GridBookmarkService'];
        constructor($q:ng.IQService, pagingService:EventService,notificationService:NotificationService,
                    gridBookmarkService:GridBookmarkService){
            super($q, pagingService,notificationService,gridBookmarkService);
        }
        getCustomActions():string[]{
            return [];
        }
        entityName():string{
            return "command";
        }
        displayName():string{
            return "Queued Commands";
        }
        addEditAllowed():boolean{
          return false;
        }
        deleteAllowed():boolean{
          return false;
        }
        getColumnDefs():ng.IPromise<void>{
            this.nameValuePairs =
                [
                    ['created', 'Created', 200],
                    ['lastAttempt', 'Last Attempt', 215],
                    ['activeTagID', 'VTag Id', 120],
                    ['assetName', 'Asset Name', 130],
                    ['assetDescription', 'Asset Description', 150],
                    ['commandType', 'Command Type', 150],
                    ['commandText', 'Command Text', 310],
                    ['status', 'Status', 135],
                    ['retryCount', 'Retry Count', 150],
                    ['reason', 'Reason', 145],
                ];
            return this.$q.when();
        }
    }
